import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyCreateCustomerAccessTokenWithMultipass = async (multipassToken) => {
  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `mutation {
          customerAccessTokenCreateWithMultipass(multipassToken: "${multipassToken}") {
            customerUserErrors {
              code
              field
              message
            }
            customerAccessToken {
              accessToken
              expiresAt
            }
          }
        }`,
      },
    });
    if (response.data.data.customerAccessTokenCreateWithMultipass) {
      const { customerUserErrors, customerAccessToken } =
        response.data.data.customerAccessTokenCreateWithMultipass;
      if (customerUserErrors.length) {
        return null;
      } else {
        return customerAccessToken.accessToken;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyCreateCustomerAccessTokenWithMultipass;
